import {
  APP_THEME_STORAGE_KEY,
  DEFAULT_APP_THEME_ID,
  isAppThemeId,
  type AppThemeId,
} from './appThemes.js';

const BS_THEME_STORAGE_KEY = 'theme';

/**
 * Applies palette + light/dark from localStorage (call on boot and after user changes).
 */
export function syncDocumentThemesFromStorage(): void {
  if (typeof document === 'undefined') {
    return;
  }
  const bs = window.localStorage.getItem(BS_THEME_STORAGE_KEY);
  document.documentElement.setAttribute('data-bs-theme', bs === 'dark' ? 'dark' : 'light');

  const raw = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
  const appTheme: AppThemeId = isAppThemeId(raw) ? raw : DEFAULT_APP_THEME_ID;
  document.documentElement.setAttribute('data-app-theme', appTheme);
}

export function getStoredAppThemeId(): AppThemeId {
  if (typeof window === 'undefined') {
    return DEFAULT_APP_THEME_ID;
  }
  const raw = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
  return isAppThemeId(raw) ? raw : DEFAULT_APP_THEME_ID;
}

export function setStoredAppThemeId(id: AppThemeId): void {
  window.localStorage.setItem(APP_THEME_STORAGE_KEY, id);
  document.documentElement.setAttribute('data-app-theme', id);
}
